import { render, staticRenderFns } from "./TrackingBulkDetails.vue?vue&type=template&id=fad5bfb6&"
import script from "./TrackingBulkDetails.vue?vue&type=script&lang=js&"
export * from "./TrackingBulkDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fad5bfb6')) {
      api.createRecord('fad5bfb6', component.options)
    } else {
      api.reload('fad5bfb6', component.options)
    }
    module.hot.accept("./TrackingBulkDetails.vue?vue&type=template&id=fad5bfb6&", function () {
      api.rerender('fad5bfb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tracking/TrackingBulkDetails.vue"
export default component.exports